<template>
    <picture-element
            :lazy="false"
            :urls="randomImg"
            v-bind="$attrs"/>
</template>

<script>
    import PictureElement from '../picture-element/picture-element';
    import { sample } from 'lodash/fp';

    export default {
        components: { PictureElement },
        props: {
            urls: {
                type: Array,
                default() {
                    return {
                        default: [],
                    };
                },
            },
        },
        computed: {
            randomImg() {
                return sample(this.urls);
            },
        },
    };
</script>
